import { jsx as _jsx } from "react/jsx-runtime";
import { StyledText } from './styles';
import { mapTextTypeToTagType } from './utils';
export const DeprecatedText = ({ asTag, textType = 'paragraph', ...rest }) => {
    const fallbackTag = mapTextTypeToTagType(textType);
    return _jsx(StyledText, { as: asTag ?? fallbackTag, textType: textType, ...rest });
};
//# sourceMappingURL=index.js.map